import { useEffect, useMemo, useRef, useState } from 'react';

import clsx from 'clsx';

import { OptimizedImage } from 'shared/components/ui/optimized-image/optimized-image';
import { useCurrenciesStore } from 'shared/store/currenciesStore';
import { getPrizeImage } from 'shared/utils/getPrizeImage';
import { CurrencyType } from 'shared/web3';

interface IRoomBoxProps {
  bet: number | null;
  token: string;
  animationsTriggered: boolean;
  streamCurrency?: CurrencyType;
}

export const RoomBox = ({ bet, token, animationsTriggered, streamCurrency }: IRoomBoxProps) => {
  const [rawBet, setRawBet] = useState<number | null>(null);
  const { availableCurrencies } = useCurrenciesStore();

  const boxRef = useRef<HTMLImageElement>(null);

  const currency = useMemo(
    () =>
      availableCurrencies.find((item) => item.address.toLowerCase() === token.toLowerCase()) ||
      streamCurrency,
    [availableCurrencies, token, streamCurrency],
  );

  useEffect(() => {
    if (bet && currency) {
      const roomBet = Number(bet) / 10 ** currency.decimals;
      setRawBet(roomBet);
    }
  }, [bet, currency]);

  return (
    <div
      ref={boxRef}
      className={clsx(
        'blur-4 absolute bottom-[60px] left-1/2 z-20 w-[180px] -translate-x-1/2 transform xs:w-[250px] sm:bottom-[120px] sm:w-[389px] lg:w-[512px]',
        animationsTriggered ? 'animate-slide-in-from-bottom' : 'animate-fast-appear',
      )}
    >
      <OptimizedImage
        imageData={getPrizeImage(rawBet, currency)}
        alt="bet-image"
        data-testid="bet-image"
      />
    </div>
  );
};
